import { buildComponent } from '../dsfr';


const Badge = buildComponent('p', 'fr-badge');

export default Badge;
